export default __webpack_public_path__ + "static/movilidad-78d2d4fcb11ec9357765d6f3b2654d64.png";